import { RouteObject } from 'react-router-dom';
import ProtectedRoute from '../components/ProtectedRoute';

// Pages publiques
import Login from '../pages/login/page';
import Register from '../pages/register/page';
import ForgotPassword from '../pages/forgot-password/page';
import NotFound from '../pages/NotFound';
import DevisPublic from '../pages/quotes/components/DevisPublic';

// Pages protégées
import Home from '../pages/home/page';
import Dashboard from '../pages/dashboard/page';
import Products from '../pages/products/page';
import Sales from '../pages/sales/page';
import PurchaseOrders from '../pages/purchase-orders/page';
import Invoices from '../pages/invoices/page';
import Quotes from '../pages/quotes/page';
import Suppliers from '../pages/suppliers/page';
import Employees from '../pages/employees/page';
import Reports from '../pages/reports/page';
import Profile from '../pages/profile/page';
import Admin from '../pages/admin/page';
import CustomersPage from '../pages/customers/page';
import CashRegisterPage from '../pages/cash-register/page';
import FinancePage from '../pages/finance/page';
import BccDetail from '../pages/sales/components/BCCDetailPage';
import DetailDeliveryNote from '../pages/sales/components/BonLivraisonDetail';
import ResetPassword from '../pages/forgot-password/ResetPassword';

const routes: RouteObject[] = [
  // Pages publiques
  { path: '/login', element: <Login /> },
  { path: '/register', element: <Register /> },
  { path: '/forgot-password', element: <ForgotPassword /> },
  { path: '/reset-password', element: <ResetPassword /> },
  { path: '/devis/public/:token', element: <DevisPublic /> },

  // Pages protégées
  { path: '/', element: <ProtectedRoute><Home /></ProtectedRoute> },
  { path: '/dashboard', element: <ProtectedRoute><Dashboard /></ProtectedRoute> },
  {
    path: '/products',
    element: <ProtectedRoute requiredPermissions={['Stocks']}><Products /></ProtectedRoute>
  },
  {
    path: '/sales',
    element: <ProtectedRoute requiredPermissions={['Ventes']}><Sales /></ProtectedRoute>
  },
  {
    path: '/sales-detail/:id',
    element: <ProtectedRoute requiredPermissions={['Ventes']}><DetailDeliveryNote /></ProtectedRoute>
  },
  {
    path: '/purchase-orders',
    element: <ProtectedRoute requiredPermissions={['Achats']}><PurchaseOrders /></ProtectedRoute>
  },
  {
    path: '/invoices',
    element: <ProtectedRoute requiredPermissions={['Ventes']}><Invoices /></ProtectedRoute>
  },
  {
    path: '/quotes',
    element: <ProtectedRoute requiredPermissions={['Ventes']}><Quotes /></ProtectedRoute>
  },
  {
    path: '/suppliers',
    element: <ProtectedRoute requiredPermissions={['Fournisseurs']}><Suppliers /></ProtectedRoute>
  },
  {
    path: '/customers',
    element: <ProtectedRoute requiredPermissions={['Ventes', 'Clients']}><CustomersPage /></ProtectedRoute>
  },
  {
    path: '/employees',
    element: <ProtectedRoute requiredRole="Administrateur"><Employees /></ProtectedRoute>
  },
  {
    path: '/finance',
    element: <ProtectedRoute requiredPermissions={['Finances']}><FinancePage /></ProtectedRoute>
  },
  {
    path: '/bcc/:id',
    element: <ProtectedRoute requiredPermissions={['Ventes']}><BccDetail /></ProtectedRoute>
  },
  {
    path: '/reports',
    element: <ProtectedRoute requiredPermissions={['Rapports']}><Reports /></ProtectedRoute>
  },
  { path: '/profile', element: <ProtectedRoute><Profile /></ProtectedRoute> },
  {
    path: '/admin',
    element: <ProtectedRoute requiredRole="Administrateur"><Admin /></ProtectedRoute>
  },
  // 🔐 Ajout de la protection (probablement oubliée)
  {
    path: '/cash-register',
    element: <ProtectedRoute requiredPermissions={['Finances']}><CashRegisterPage /></ProtectedRoute>
  },

  // 404
  { path: '*', element: <NotFound /> },
];

export default routes;